import { render, staticRenderFns } from "./KpisIncentivePlansSummaryQuestion.vue?vue&type=template&id=2aff9091&scoped=true"
import script from "./KpisIncentivePlansSummaryQuestion.vue?vue&type=script&lang=js"
export * from "./KpisIncentivePlansSummaryQuestion.vue?vue&type=script&lang=js"
import style0 from "./KpisIncentivePlansSummaryQuestion.vue?vue&type=style&index=0&id=2aff9091&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aff9091",
  null
  
)

export default component.exports